<template>
  <div class="ml-1 mb-1">
    <h3 style="color: red">{{ queueNumbers }}</h3>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'queues-div-component',
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    ...mapGetters('order', [
      'queues'
    ]),
    queueNumbers () {
      if (this.queues.length > 0) {
        const text = ((this.queues.length === 1) ? this.$t('queue_no') : this.$t('queue_nos')) + ': '
        const numbers = this.queues.map(q => q.slice(-3))
        return text + numbers.join(', ')
      }
      return null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QueuesDiv.vue